var $ = require('jQuery');
import Component from './Component';
import Observer from './Observer';
import Watcher from './Watcher';
import defineReactive from './DefineReactive';
import createNewTree from './CreateNewTree';
import createDomTree from './CreateDomTree';
import SetDataVnodeWatchers from './SetDataVnodeWatchers';
import TreePatch from './TreePatch';
import { nextTick } from './NextTick';
import { extend, scanAndSet, isObject, scanAndCompare } from './util';

const isValidArrayIndex = function (val) {
    return !isNaN(val) && (val >=0);
}
// let ccc = {
//     lmj : {
//         mate: 'likd-a'
//     }
//  }

//  let aaa = new Observer(ccc);

//  let bbb = new Watcher(ccc, 'lmj.mate', function(){
//     console.log('likd-a');
//  });

//  window.ccc = ccc;

class Vm extends Component{
    constructor (options) {
        super(options);
        this._element = null;
        // 数据
        this._children = {};         // 子组件
        this._options = options;
        // framework ?
        if (options && options.is_vm) {
            this.setData = this.vm_setData;
            this._vm_data = this.vm_data();
            this._data = this.vm_data();
            this._vm_data = { ...this._vm_data, ...options.data }
            this._data_vnode_vm_row = [];
            this._data_vnode_changes = [];
            this._data_vnode_changes_hash = {};
            this._data_vnode_change_promise;
            this._vm_methods = this.pack_methods();;
            this.renderFromTemplate();
        } else {
            (function (self) {
                if (self._options.template) {
                    self._element = $(self._options.template);
                }
            })(this);
        }
    }

    vm_data() {
        return {

        }
    }

    vm_template() {
        return {

        }
    }

    vm_methods() {
        return {

        }
    }

    data() {
        return {

        }
    }

    $watch(expOrFn, cb, options) {
        const vm = this;
        options = options || {};
        const watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            cb.call(vm, watcher.value);
        }
        return function unwatchFn () {
            watcher.teardown();
        }
    }

    $set(target, key, val) {
        if (Array.isArray(target) && isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            return val;
        }

        if (key in target && !(key in Object.prototype)) {
            target[key] = val;
            return val;
        }

        const ob = target.__ob__;
        if (target.__isVue || (ob && ob.vmCount)) {
            return val;
        }

        if (!ob) {
            target[key] = val;
            return val;
        }
        defineReactive(ob.value, key, val);
        ob.dep.notify();
        return val;
    }

    $delete(target, key) {
        if (Array.isArray(target) && isValidArrayIndex(key)) {
            target.splice(key, 1);
            return;
        }
        const ob = (target).__ob__;
        if (target.__isVue || (ob && ob.vmCount)) {
            return;
        }
        if (!hasOwn(target, key)) {
            return;
        }
        delete target[key];

        if (!ob) {
            return;
        }
        ob.dep.notify();
    }

    renderFromTemplate() {
        let self = this;
        this.__ob__ = new Observer(this._vm_data);
        let newTree = createNewTree.call(this, this._vm_data, true);
        this._old_tree = newTree;
        this._element = createDomTree(newTree.template);
        this._vm_element = this._element;
        this._element = $(this._element);
        SetDataVnodeWatchers(this._vm_data, newTree.watched, (change)=>{
            if (!self._data_vnode_changes_hash[change]) {
                self._data_vnode_changes_hash[change] = true;
                self._data_vnode_changes.push(change);
            }
        });
    }

    pack_methods() {
        let self = this;
        let packed = {};
        let methods = this.vm_methods();
        for(let key in methods) {
            if (typeof methods[key] === 'function') {
                packed[key] = methods[key].bind(self);
            }
        }
        return packed;
    }

    vm_setData(newData, cover, callback) {
        let self = this;
        scanAndSet(newData, self._data);
        
        let components = typeof self.components === 'function' ? self.components() : {};
        if (!self._data_vnode_change_promise) {
            self._data_vnode_change_promise = nextTick(function(){
                let _newData = self.mutation(self._data);
                if (isObject(_newData)) {
                    scanAndCompare(_newData, self._vm_data, cover || false);
                }
                if (self._data_vnode_changes.length) {
                    let newTree = createNewTree.call(self, self._vm_data);
                    TreePatch.call(self, self._old_tree.template, newTree.template, components);
                    self._old_tree = newTree;
                }
                self._data_vnode_changes = [];
                self._data_vnode_changes_hash = {};
                self._data_vnode_change_promise = null;
                typeof callback === 'function' && callback();
            });
            self._data_vnode_change_promise();
        }
    }

    createKey() {
        return;
    }

    mutation(newData) {
        return newData
    }

    getElement() {
        return this._element;
    }

    vm_get_element(){
        return this._vm_element;
    }
 }

 export default Vm